import NavBar from '@/components/Nav.vue';

export default {
    name: 'ActivityPage',
    components: {
        NavBar,
    },
    data() {
        return {
            page: 1,
            more: true,
            loading: false,
            activities: []
        }
    },
    created() {
        this.getActivityList();
    },
    mounted() {
        window.addEventListener('scroll', this.scroll, true);
    },
    unmounted() {
        window.removeEventListener('scroll', this.scroll, true);
    },
    methods: {
        getActivityList() {
            if (this.more && ! this.loading) {
                this.loading = true;
                this.$http.get('activity', {params: {page: this.page}}).then(result => {
                    this.page++;
                    this.loading = false;
                    this.more = result.data.more;
                    this.activities = this.activities.concat(result.data.activities);
                })
            }
        },
        scroll() {
            let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            this.showGoTopBtn = scrollTop > 1000;
            if (document.documentElement.scrollHeight - scrollTop - document.documentElement.clientHeight <= 100) {
                this.getActivityList();
            }
        }
    }
}